import FloatingPopper, { ForcedPopperPositions } from "@components/floatingPopper/FloatingPopper";
import { Middleware } from "@floating-ui/dom";
import { Placement, VirtualElement } from "@floating-ui/react-dom";
import { updateStyleAccordingToZoomLevel } from "@utils/zoom.utils";
import React, { ReactNode } from "react";
import ReactDOM from "react-dom";

import { StyledPopperWrapper } from "./PopperWrapper.styles";

export interface IPopperOptions {
    placement?: Placement;
    modifiers?: Middleware[];
}

// either use reference (element) for positioning,
// or virtualElementReference e.g. if you want to position the popper relative to mouse
interface IReferenceProps {
    reference: (ref: React.Ref<any>) => React.ReactNode;
    virtualElementReference?: never;
}

interface IVirtualElementReferenceProps {
    reference?: never;
    virtualElementReference: HTMLElement | VirtualElement;
}

interface IProps extends IPopperOptions {
    withoutPortal?: boolean;
    isHidden?: boolean;
    forcedPosition?: ForcedPopperPositions
}

type TProps = IProps & (IReferenceProps | IVirtualElementReferenceProps);

export default class PopperWrapper extends React.PureComponent<TProps> {
    _openerRef = React.createRef<HTMLDivElement>();

    render() {
        return (
                <>
                    {!this.props.virtualElementReference && this.props.reference(this._openerRef)}
                    {!this.props.isHidden &&
                            <FloatingPopper
                                    referenceElement={this.props.virtualElementReference ?? this._openerRef?.current}
                                    placement={this.props.placement}
                                    useZoomCorrection={true}
                                    forcedPosition={this.props.forcedPosition}
                                    modifiers={[...(this.props.modifiers ?? [])]}>
                                {(popperProps) => {
                                    if (!this.props.children) {
                                        return null;
                                    }

                                    popperProps.style = updateStyleAccordingToZoomLevel(popperProps.style);
                                    let Object = (
                                            <StyledPopperWrapper ref={popperProps.ref}
                                                    // Note: we can't extend styles here like { ...popperProps.style, zIndex: 10 }
                                                    //  -> it throws exception on production
                                                                 style={popperProps.style}
                                                                 data-popper-placement={popperProps.placement}>
                                                {this.props.children}
                                            </StyledPopperWrapper>
                                    );

                                    if (!this.props.withoutPortal) {
                                        Object = ReactDOM.createPortal(
                                                Object,
                                                document.body
                                        );
                                    }

                                    return Object as ReactNode;
                                }}
                            </FloatingPopper>
                    }
                </>
        );
    }
}